// extracted by mini-css-extract-plugin
export default {"root":"styles__root--+vuLg","wrapper":"styles__wrapper--wumeX","title-only":"styles__title-only--l06oG"};